import Vue from "vue";
import { randomValue } from "@/lib/random";
import { LOCAL, ROOT_FLAG } from "@/store/mutations";

const { DISABLE_CURVEBALL_ACTIVATION } = LOCAL;

export default {
	namespaced: true,
	state: () => ({
		id: null,
		title: "",
		target_payout: 0,
		budgets: {},
		travel_video: {},
		curveballs: {
			activate: true,
			available: [],
		},
	}),
	getters: {
		serveCurveball: (state, getters, rootState, rootGetters) => state.curveballs.activate && !rootGetters["game/curveballs/active"],
		servableCurveballs: (state, getters, rootState, rootGetters) => state.curveballs.available.filter(
			(id) => rootGetters[`game/curveballs/${id}/servable`]
		),
		randomAffordableCurveballId: (state, getters) => () => randomValue(getters.servableCurveballs),
	},
	actions: {
		activate({ dispatch, state }) {
			dispatch("global/analytics/trackPageView", { dp: state.title }, ROOT_FLAG);
			dispatch("global/assets/loadFile", {
				id: state.travel_video.id,
				url: state.travel_video.url,
			}, ROOT_FLAG);
		},
		disableCurveball({ commit }) {
			commit(DISABLE_CURVEBALL_ACTIVATION);
		},
	},
	mutations: {
		[DISABLE_CURVEBALL_ACTIVATION](state) {
			Vue.set(state.curveballs, "activate", false);
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/chapters/single.store.js